// src/data/programModules.js

const programModules = [
 {
  slug: "digital-marketing-mentorship-program",
  modules: [
    {
      moduleNumber: 1,
      heading: "Fundamentals of Digital Marketing",
      content: "In this week, We will covers setting marketing objectives, conducting market and competitor research, understanding the marketing funnel and customer journey, identifying target audience segments, creating buyer personas, developing value propositions, key digital marketing terms and metrics, media types, digital marketing channels, selecting the right channel mix, and case studies for each channel."
    },
    {
      moduleNumber: 2,
      heading: "Fundamentals of Paid Marketing",
      content: "This week, you'll learn how to structure and launch paid ad campaigns on Google and Meta. From understanding campaign types, funnel mapping, and bidding strategies to building full-funnel campaigns and writing compelling ad copy—this hands-on module equips you with the tools to set up and run live campaigns using Google Ads Manager and Meta Ads Manager."
    },
    {
      moduleNumber: 3,
      heading: "Conversion Tracking + Media Planning",
      content: "This week, you'll learn how to set up end-to-end conversion tracking using GA4, GTM, and Microsoft Clarity, and understand why it's crucial for campaign success. You'll also dive into media planning—profiling audiences, selecting channels, setting KPIs, and allocating budgets—to build a structured, goal-driven plan across platforms for real-world campaigns."
    },
    {
      moduleNumber: 4,
      heading: "AI automations in Paid Marketing",
      content: "This week, you'll learn how to automate the entire paid marketing workflow using AI. From researching competitors and building campaign structures to auto-defining budgets, pulling live performance data, and spotting scaling opportunities—this 5-step AI-driven approach leverages tools like ChatGPT, Make.com, and Google Sheets to streamline campaign setup, analysis, and optimization."
    }
  ]
},
 {
  slug: "performance-marketing-mentorship-program",
  modules: [
    {
      moduleNumber: 1,
      heading: "Performance Marketing Foundations & Industry Landscape",
      content: "Evolution of Performance Marketing: Trends in India & Globally. Key Terminologies: CAC, LTV, ROAS, Conversion Rates. B2B vs. B2C Performance Marketing: Strategic Differences. Funnel-Based Strategies: TOFU, MOFU & BOFU"
    },
    {
      moduleNumber: 2,
      heading: "Meta Ads Mastery (Facebook & Instagram)",
      content: "Introduction to Meta Ads – Platform Deep Dive. Campaign Objectives & Funnel Mapping (TOFU, MOFU, BOFU). ABO vs. CBO Bidding Strategies. Retargeting & Lookalike Audience Strategies. AI-Powered Meta Ads & ROAS Optimization"
    },
    {
      moduleNumber: 3,
      heading: "Google Ads Mastery",
      content: "Search Intent & Ad Rank: How it Works. Smart Bidding: Target ROAS, Max Conversions. Performance Max & Display Campaign Best Practices. Google Discovery Ads & Demand Generation Strategies. YouTube Ads: Targeting, Optimization, and Impact. Privacy-First Marketing & First-Party Data Collection"
    },
    {
      moduleNumber: 4,
      heading: "Emerging Ad Platforms",
      content: "LinkedIn, Apple, Amazon, Flipkart & Native Ads Overview. Platform-Specific Campaign Objectives & Targeting. Native Ads & Display Network Combinations. Media Mix Modeling (MMM). Strategic Budget Allocation for Emerging Platforms"
    },
    {
      moduleNumber: 5,
      heading: "Crafting High-Converting Ad Creatives",
      content: "Ad Copy Psychology: Emotional & Behavioral Triggers. Static vs. Motion-Based Creative Best Practices. AI-Generated Ad Creatives & Personalization. A/B Testing for Creative Optimization. Performance Measurement & Continuous Improvement"
    },
    {
      moduleNumber: 6,
      heading: "E-commerce & DTC Performance Advertising",
      content: "Google Shopping Campaigns: Setup & Optimization. Feed Optimization & Google Merchant Center Setup. Amazon Sponsored Ads vs. Flipkart PLAs. CRO Techniques for eCommerce. Retargeting Funnels for D2C Growth"
    },
    {
      moduleNumber: 7,
      heading: "Media Planning & Buying – Part 1",
      content: "Fundamentals of Media Planning. Funnel-Based Media Strategy Selection. Media Mix Modeling & Platform Selection. Strategic Budget Allocation for Maximum Impact. Planning Across Multiple Verticals"
    },
    {
      moduleNumber: 8,
      heading: "Media Planning & Buying – Part 2",
      content: "Planning Metrics for App-Based & Web Campaigns. Multi-Touchpoint Testing Strategies. Predictive Budget Modeling for ROI. Advanced Pricing Models: CPM, CPC, CPL. Scaling Ad Spend Systematically"
    },
    {
      moduleNumber: 9,
      heading: "GA4 & Advanced Analytics",
      content: "GA4 Setup: Custom Events, Goals & Enhanced Tracking. Cross-Domain & Multi-Channel Attribution. Data Visualization & Performance Reporting. AI-Based Conversion Forecasting. Predictive Models for Budget Planning"
    },
    {
      moduleNumber: 10,
      heading: "Attribution & Automation in Performance Marketing",
      content: "Attribution Models: First Click, Last Click, Data-Driven, MTA. AI-Powered Auto-Bidding & Optimization. Tools: Meta AI, Reveal Bot, Segment.io, Attribution.ai. Dynamic Creative Personalization. Cookieless Tracking & Privacy-First Strategies"
    },
    {
      moduleNumber: 11,
      heading: "Attribution & Automation in Performance Marketing",
      content: "Attribution Models: First Click, Last Click, Data-Driven, MTA. AI-Powered Auto-Bidding & Optimization. Tools: Meta AI, Reveal Bot, Segment.io, Attribution.ai. Dynamic Creative Personalization. Cookieless Tracking & Privacy-First Strategies"
    }
  ]
},
  {
    slug: "ui-ux-design-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Discovering Design",
        content:
          "Overview of design fundamentals and elements such as color, font, spacing, and more.",
      },
      
      {
        moduleNumber: 2,
        heading: "Introduction to UX Design",
        content:
          "Discover the significance of UX design in the product development process and distinguishing it from UI Design.",
      },
      {
        moduleNumber: 3,
        heading: "Understanding Users and User Research",
        content:
          "Learn effective user research techniques and their importance in driving design decisions.",
      },
        {
        moduleNumber: 4,
        heading: "UX Research",
        content:
          "Explore the core techniques and methodologies of UX research, including usability testing, user personas, and journey mapping, to gather insights that drive user-centered design decisions.",
      },
      
         {
        moduleNumber: 5,
        heading: "Design Thinking Stages of design",
        content: "Thinking: Empathize, Define, Ideate, Prototype, and Test.",
      },
        {
        moduleNumber: 6,
        heading: "Wireframing and Prototyping",
        content:
          "Tools and techniques for wireframing, the transition from low-fidelity to high-fidelity prototypes.",
      },

      {
        moduleNumber: 7,
        heading: "User Interface Design for Digital Devices",
        content:
          "Dive into the fundamentals of UI design, focusing on creating intuitive and visually appealing interfaces for various digital devices, with an emphasis on mobile and web applications.",
      },
   
    
      {
        moduleNumber: 8,
        heading: "Interaction Design Principles",
        content:
          "Design Principles of interaction design, designing for different device responsive design.",
      },
      {
        moduleNumber: 9,
        heading: "Usability Principles Key",
        content:
          "Principles of usability in UX design, Jakob Nielsen’s Usability Heuristics.",
      },
      {
        moduleNumber: 10,
        heading: "Visual Design",
        content:
          "Visual Design with UX Importance of visual elements in UX, color theory, typography, and layout.",
      },
      {
        moduleNumber: 11,
        heading: "Motion Design",
        content:
          "Discover the principles of motion design and its impact on user experience. Learn to craft smooth, engaging animations and transitions that enhance the interactivity and visual appeal of digital interfaces.",
      },
    
      {
        moduleNumber: 12,
        heading: "AI for Design",
        content:
          "Learn how artificial intelligence can be leveraged in UX/UI design to automate processes, enhance user experiences, and create adaptive interfaces that anticipate user needs.",
      },
      {
        moduleNumber: "13 & 14",
        heading: "Portfolio and Career Prep",
        content:
          "Prepare for a successful career in UX design with guidance on building a compelling portfolio, and understanding industry expectations to stand out as a top candidate.",
      },
      {
        moduleNumber: "15 & 16",
        heading: "Capstone Project",
        content:
          "Develop a portfolio-ready capstone project in the final two weeks. Solve a real-world design problem to refine and test your skills. Receive expert guidance and feedback from industry leaders.",
      },
    ],
  },
  {
    slug: "product-management-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Understanding Product Management",
        content:
          "The module covers the evolution and definitions of product management, detailing the roles, responsibilities, and factors influencing PMs, alongside archetypes. It also explores the product development lifecycle, team roles, functions, and the career trajectory of a product manager.",
      },
      {
        moduleNumber: 2,
        heading: "Foundational skills",
        content:
          "The module delves into essential thinking skills for problem-solving and decision-making, including structured, MECE, first principles, and higher-order thinking. It emphasizes the importance of creative, data-driven, and hypothesis-driven approaches to enhance analytical capabilities.",
      },
      {
        moduleNumber: 3,
        heading: "Problem discovery and Market understanding",
        content:
          "The module explores market analysis techniques including viability, sizing, and STP strategies, alongside user research methodologies ranging from qualitative to quantitative, and primary to secondary. It also covers the user interview process, from recruitment to synthesizing learnings and developing user personas.",
      },
      {
        moduleNumber: 4,
        heading: "Strategy framing",
        content:
          "The module covers comprehensive industry and market analysis using Porter's Five Forces and PESTEL, company assessments through SWOT, and strategic planning including vision, mission, and value chains. It details strategy formulation from corporate to product strategy highlighting competitive advantages, strategic alignment, and effective goal setting with SMART goals and OKRs.",
      },
      {
        moduleNumber: 5,
        heading: "Solution ideation",
        content:
          "The module explores product solutions, detailing the process from conceptualizing unique ideas to disruptive innovations, and delves into UI/UX design from wireframes to usability principles. It covers system design, modern tech trends, and essential success metrics, including AARRR and HEART frameworks, concluding with strategies for defining and balancing MVPs.",
      },
      {
        moduleNumber: 6,
        heading: "Solution execution",
        content:
          "The module covers the essentials of Product Requirement Documents (PRDs), including their definition, structure, and criteria for effectiveness. It explores Agile development methodologies, focusing on scrum practices, sprint ceremonies, and the Kano model. Additionally, it addresses meeting strategies, stakeholder management, and best practices for balancing shallow and deep work.",
      },
      {
        moduleNumber: 7,
        heading: "Launching and learning",
        content:
          "The module explores quality assurance processes, launch strategies, and cross-functional readiness for effective rollouts, including change management. It covers usability testing techniques like the Mom test, introduces A/B testing with a statistical focus, and delves into analytics platforms, emphasizing data management, visualization, and privacy compliance.",
      },
      {
        moduleNumber: 8,
        heading: "Interview prep",
        content:
          "The module delves into the recruitment process, focusing on resume building and developing a case study portfolio. It explores various case-based question types, product design, and strategy frameworks, providing examples and methods for tackling product case questions effectively.",
      },
    ],
  },
{
  slug: "management-consulting-mentorship-program",
  modules: [
    {
        moduleNumber: 0,
        heading: "Introduction to Consulting",
        content:
          "Gain insight into consulting careers, key skills, firm operations, industry trends, and pathways. Explore entry strategies, prominent firms, practice types, and a real-life case study.",
      },
    {
      moduleNumber: 1,
      heading: "Foundations of Strategic Problem Solving",
      content:
        "How consultants define and structure business challenges. Introduction to structured thinking and why it matters. Learn the first two steps of the 7-step problem-solving process. Define clear problem statements and build initial hypotheses. Use MECE and Issue Trees to break down complex problems.",
    },
    {
      moduleNumber: 2,
      heading: "Prioritization & Workplan Design",
      content:
        "How consultants decide what to solve first and plan their work. Use prioritization frameworks to identify high-impact areas. Convert insights into a clear, actionable workplan. Learn to structure and sequence tasks logically. Build a high-level consulting workplan in a team breakout.",
    },
    {
      moduleNumber: 3,
      heading: "Analyze and Recommend",
      content:
        "Learn how to turn data into actionable insights. Collect relevant data and identify patterns. Apply structured thinking to analyze the problem. Synthesize key findings and build sharp recommendations. Understand how consultants pressure-test ideas before presenting them.",
    },
    {
      moduleNumber: 4,
      heading: "Storyline Building for Strategy Presentations",
      content:
        "Learn how to present your ideas like a consultant. Structure your message using storytelling frameworks. Communicate ideas clearly to decision-makers. Create a 5-slide storyline and kick off your group case. Learn the dos and don'ts of persuasive slide design in consulting.",
    },
    {
      moduleNumber: 5,
      heading: "Case Interview Mastery",
      content:
        "Understand how to structure and solve cases under pressure. Learn the different types of consulting case interviews and what interviewers expect. Practice structuring your thoughts and thinking out loud. Solve a mock case in real time with expert guidance. Avoid common interview pitfalls and follow proven best practices.",
    },
    {
      moduleNumber: 6,
      heading: "Career Strategy and Resume Building",
      content:
        "Craft a resume and strategy roadmap for breaking into consulting roles. Map out your transition into consulting and strategy pathways. Reframe your resume to highlight problem-solving and structured thinking. Write strong, impact-driven resume bullets using the RAC framework. Get started with a case prep checklist and personalized career guidance.",
    },
    {
      moduleNumber: 7,
      heading: "AI-Assisted Consulting Foundations",
      content:
        "Learn the foundations of AI-assisted consulting work. Explore how GPT and AI tools can speed up analysis and thinking. Craft better prompts to generate sharper insights. Use AI for research, synthesis, and benchmarking. Understand data privacy and ethical use of AI in consulting.",
    },
    {
      moduleNumber: 8,
      heading: "Automation and AI Workflows",
      content:
        "Learn to automate repetitive tasks using simple AI tools. Build a beginner-friendly automation using Gumloop or Make.com. Automate research briefs, synthesis, and deck creation. Discover how to save hours with AI-powered workflows. Learn what it means to be a T-Shaped Consultant.",
    },
  ],
},
  {
    slug: "product-marketing-mentorship-program",
    modules: [
      {
        moduleNumber: 1,
        heading: "Product Market Familiarization",
        content:
          "Master the fundamentals of product marketing with a deep dive into key frameworks, techniques, and industry nuances. This program covers essentials such as market research, positioning frameworks, messaging loops, GTM strategies, and the AARRR funnel, while also exploring team structures and the market mix model. You'll develop strong analytical and project management skills, enabling you to create impactful marketing roadmaps. The journey culminates in a thought-provoking project, If You Were A Product, where you'll identify your target market, craft positioning strategies, design sales collateral, and develop a go-to-market plan—combining self-reflection with strategic execution.",
      },
      {
        moduleNumber: 2,
        heading: "Product Marketing Metrics",
        content:
          "Master the art of product marketing metrics with this comprehensive module. Learn to measure, analyze, and strategically select the right metrics to optimize your marketing efforts. Discover how Product, Marketing, and Sales teams define success, explore critical product metrics, and understand the nuanced differences between OKRs, KPIs, and KRIs. Delve deeper into TMoS, SQLs, and PQLs to enhance decision-making. As a hands-on project, benchmark your organization’s metrics against industry standards, assign satisfaction scores, and establish actionable goals to drive improved performance analysis.",
      },
      {
        moduleNumber: 3,
        heading: " Product Building - Nailing the Product",
        content:
          "This program equips you with the skills to define your Target Market, craft compelling messages, and determine Product Requirements with a focus on creating an Ideal Customer Profile (ICP), market positioning, and achieving product-market fit. You’ll dive into topics like defining your ICP using data sources, applying Messaging WTP (Willingness To Pay) and Pricing Frameworks, and utilizing Feature Prioritization frameworks through competitor benchmarking and market research. Additionally, you’ll explore go-to-market strategies, user flows, and features, and learn to write a precise Product Requirements Document (PRD). The 5Cs Approach and SCAN (Sticky Custom Audience Network) method will also be covered. As part of the project, you’ll define your ICP, benchmark competitors, conduct customer interviews for WTP insights, and build a comprehensive PRD.",
      },
      {
        moduleNumber: 4,
        heading: "Demand Generation",
        content:
          "Master demand generation by learning how to create high-converting campaigns, craft effective storytelling, and apply analytical techniques to drive execution and feature adoption. The course covers critical frameworks for Go-To-Market (GTM) strategies, key demand generation steps in product marketing, revenue-based budgeting, ROI, and influencer management. It also includes campaign optimization strategies and success frameworks, with a case study on The Force Awakens Star Wars campaign. Through a hands-on project, you’ll dive into product marketing writing, receive peer feedback for improvement, and design Go-To-Market strategies using the CCEBT framework to build a strong foundation in practical marketing campaign execution.",
      },
      {
        moduleNumber: 5,
        heading: "Revenue Realisation - Making the cash flow in",
        content:
          "This program focuses on enhancing sales effectiveness by driving revenue realization through a deep understanding of key metrics, such as NPS calculations and win-loss analysis, while developing competitive intelligence. Topics covered include the significance of sales training, how to apply the ICE framework to various collateral types, approaches to win-loss analysis, writing impactful collaterals, pricing frameworks, and CRM integration insights. A case study on sales enablement at WWO is also included. The project involves building a range of sales collaterals—such as a 1-pager, 2-pager, competitor comparison, and datasheet—while also conducting a win-loss analysis to identify critical factors influencing sales success and areas for improvement.",
      },
      {
        moduleNumber: 6,
        heading: "Acing the game",
        content:
          "This program helps you develop essential marketing skills, including storytelling, data-driven marketing, and digital tool mastery, while gaining hands-on experience in customer engagement. You'll learn how to analyze customer data, use the ICE Framework for digital engagement and personalization, and create compelling content. The program also covers driving product messaging frameworks, product sales mapping with tools like Trello, Jira, or Monday, and understanding the Voice of Customer. Through a case study, you'll apply your knowledge of marketing moments and data analytics, crafting a compelling case study based on customer insights and demonstrating your ability to influence decision-making.",
      },
      {
        moduleNumber: 7,
        heading: " Bonus Week",
        content:
          "In this course, you'll gain a comprehensive understanding of a product marketer's role, including their daily activities, essential tools, and decision-making frameworks. You'll learn how to align marketing strategies with business goals, leverage tools, hacks, and cheat sheets for efficiency, and dive into customer analysis techniques to better understand your audience. The course also covers how to tackle everyday challenges product marketers face and how to set and achieve revenue goals, equipping you with the practical skills needed to excel in the field.",
      },
    ],
  },
  {
    slug: "workshops/chatgpt-workshop",
    modules: [
      {
        moduleNumber: 1,
        heading: "ChatGPT and 15+ AI tools",
        content:
          "Unlock the full potential of ChatGPT using the magic prompt formula to produce the most accurate, precise and reliable information at your fingertips.",
      },
      {
        moduleNumber: 2,
        heading: "Data Analysis and with ChatGPT",
        content:
          "Leverage ChatGPT's advanced data analysis capabilities to: Unearth actionable insights for refining market strategies and outperforming competitors. Dissect consumer sentiments and behavior, providing you a competitive edge in understanding market trends and customer preferences.",
      },
      {
        moduleNumber: 3,
        heading: " Content Creation with AI",
        content:
          "Implement AI-powered content generation tools to: automate repetitive tasks such as social media posts and email newsletters, freeing up time for strategic planning and creativity. personalize content based on your user demographics and behavior, enhancing engagement and conversion rate. identify trending topics and relevant industry news, enabling timely and relevant content creation that resonates with your audience..",
      },
      {
        moduleNumber: 4,
        heading: "AI Powered Powerpoint Presentations",
        content:
          "Analyse market trends without coding skills or statistical analysis. Leverage AI-driven data analysis platforms to extract actionable insights from large datasets, empowering you with informed decision-making in marketing strategy development.",
      },
      {
        moduleNumber: 5,
        heading: "Speed up Your Job Hunting",
        content:
          "Integrate AI-powered analytics tools into marketing presentations to: provide real-time data insights and dynamic visualizations, enhancing audience engagement and comprehension. optimize marketing spreadsheet data, identifying key performance indicators and forecasting future trends with accuracy. automate the creation of compelling narratives and visual elements to enhance storytelling and impact",
      },
      {
        moduleNumber: 6,
        heading: "Elevate Reading Abilities 10x instantly",
        content:
          "Explore ChatGPT API integration in: customer service chatbots to deliver personalised and contextually relevant responses, enhancing customer satisfaction and loyalty. social media management platforms to automate content creation and engagement, optimising marketing efforts across diverse channels. Learn all about ChatGPT's new vision capabilities where AI can now see, hear, and interpret data.",
      },
      {
        moduleNumber: 7,
        heading: " Build a Personal Brand with AI",
        content:
          "Utilize AI for: Identifying relevant job opportunities tailored to your skills and experience, streamlining the job hunting process. Resume optimisation and tailoring your application materials for specific job roles and industries, increasing your chances of success. personalised guidance and resources for skill development and career advancement in the marketing field.",
      },
         {
        moduleNumber: 8,
        heading: "Supercharge Email Skills 10x Instantly",
        content:
          "Explore how generative AI tools can: automate content creation tasks to produce high-quality content efficiently. crafting engaging content for personal branding efforts to enhance visibility and credibility in their respective fields.",
      },
            {
        moduleNumber: 9,
        heading: " Experience AI's Audio Video Wonders",
        content:
          "Utilize AI-powered tools and GPT 4.5 Turbo for: text summarisation to extract key insights quickly and efficiently. Dissect consumer sentiments and behavior, providing you a competitive edge in understanding market trends and customer preferences. localize marketing content for global audiences while maintaining linguistic nuances and authenticity.",
      },
    ],
  },
    {
    slug: "workshops/linkedin-growth",
    modules: [
      {
        moduleNumber: 1,
        heading: "The Powerful Client Sniper Technique",
        content:
          "Find your exact potential clients on LinkedIn without spending a dollar in ads.",
      },
      {
        moduleNumber: 2,
        heading: "The 100M Content Formula",
        content:
          "Step by step LinkedIn content writing syntax to drive 4X engagement.",
      },
      {
        moduleNumber: 3,
        heading: " Acceptance Rate Skyrocket Formula",
        content:
          "Learn strategies to connect with an A-list network and skyrocket your acceptance rate.",
      },
      {
        moduleNumber: 4,
        heading: "Unlocking the potential of AI for LinkedIn",
        content:
          "Learn 10+ AI tools to automate tasks and generate content ideas with 10X efficiency.",
      },
      {
        moduleNumber: 5,
        heading: "The 7-Touchpoint Outbound System",
        content:
          "Master the 7 touch points to nurture connections before even sending them your first message.",
      },
      {
        moduleNumber: 6,
        heading: "Million-Dollar Lead Generation Process",
        content:
          "Generated over 2,00,00,000 in revenue for me and my clients using this process.",
      },
      {
        moduleNumber: 7,
        heading: "Reverse engineering TG OPN technique",
        content:
          "Search and connect with the right open-wallet leads that are keen to work with you.",
      },
         {
        moduleNumber: 8,
        heading: "AI-Powered Profile Optimization",
        content:
          "Learn how to beat the best performing profile and rank on LinkedIn search by leveraging AI",
      }
    ],
  },
      {
    slug: "workshops/ai-for-consultants",
    modules: [
      {
        moduleNumber: 1,
        heading: "The 4-step Magic Prompt formula",
        content:
          "Unlock the full potential of ChatGPT using the magic prompt formula to produce the most accurate, precise, and reliable information at your fingertips.",
      },
      {
        moduleNumber: 2,
        heading: "AI-Enhanced Scenario Modeling",
        content:
          "Use ChatGPT for predictive analysis, improving strategy depth. Offer data-driven insights to boost client engagement and business impact.",
      },
      {
        moduleNumber: 3,
        heading: " Redefine Strategy with AI",
        content:
          "Learn how ChatGPT enhances strategic planning, offering you the skills to refine and elevate your strategy with advanced AI insight",
      },
      {
        moduleNumber: 4,
        heading: "Mastering Market Analysis",
        content:
          "Refine strategies with market insights. Analyze consumer behavior for competitive advantage in understanding market trends and preferences.",
      },
      {
        moduleNumber: 5,
        heading: "AI Efficiency in Consulting",
        content:
          "Gain actionable insights on integrating AI to save significant time, enhance your efficiency, and focus on high-impact consulting activities.",
      },
      {
        moduleNumber: 6,
        heading: "Data Analysis Made Easy",
        content:
          "Leverage AI-driven data analysis platforms to extract actionable insights from large datasets, empowering you with informed decision-making in strategy development.",
      },
      {
        moduleNumber: 7,
        heading: "Unlock Consulting Opportunities",
        content:
          "Use AI to find consulting projects, optimize proposals, and get personalized insights for professional development in the consulting industry.",
      },
     
    ],
  },
          {
    slug: "workshops/product-management",
    modules: [
      {
        moduleNumber: 1,
        heading: "Introduction to Product Management",
        content:
          "What is a Product? Understanding the Basics Defining, Product Management Scope and Importance The Role of a Product Manager: Key Responsibilities and Expectations",
      },
      {
        moduleNumber: 2,
        heading: "The Product Manager's Path",
        content:
          "Exploring Types of Product Managers, Mapping the Career Growth and Opportunities, Essential Skills needed for Product Management",
      },
      {
        moduleNumber: 3,
        heading: "Mastering Problem Solving as a PM",
        content:
          "Types of Problems Encountered by PMs, Strategic Approach to Problem Solving, Case Study Problem Solving in Action at Uber",
      },
      {
        moduleNumber: 4,
        heading: "Landing Your PM Role",
        content:
          "Demystifying the PM Recruitment Process, Crafting the Perfect PM Resume, Preparing for Common Interview Questions",
      },
      {
        moduleNumber: 5,
        heading: "Interactive Q&A Session",
        content:
          "Get personalized advice and answers to your burning questions in real-time.",
      },
    ],
  },
               {
    slug: "workshops/marketing-mastermind",
    modules: [
      {
        moduleNumber: 1,
        heading: "Your Personal AI MARKETING ASSISTANT That Works 24/7",
        content:
          "Create a Custom GPT that writes high-converting copy while you sleep!",
      },
      {
        moduleNumber: 2,
        heading: "The NO-CODE AUTOMATION BLUEPRINT That Saves 15+ Hours/Week",
        content:
          "Connect AI tools that automatically generate, schedule, and optimize your campaigns.",
      },
      {
        moduleNumber: 3,
        heading: "The VISUAL MARKETING MASTERY System:",
        content:
          "Create stunning images and videos using MidJourney and Runway ML (even with zero design skills).",
      },
      {
        moduleNumber: 4,
        heading: "The ONE-PERSON ARMY Marketing Blueprint:",
        content:
          "Build systems to single-handedly run campaigns that normally require 3-5 specialists.",
      },
      {
        moduleNumber: 5,
        heading: "The AI TOOL BLACK BOOK (35+ Cutting-Edge Tools):",
        content:
          "Get insider access to the FULL arsenal of AI marketing weapons beyond just ChatGPT.",
      },
        {
        moduleNumber: 6,
        heading: "The PERFECT PROMPT FORMULA For Guaranteed Results:",
        content:
          "Master our 5-part prompt structure that gets perfect results from any AI tool, every time.",
      },
      {
        moduleNumber: 7,
        heading: "The SET & FORGET Lead Generation System",
        content:
          "Build workflows that find, qualify, and nurture leads while you focus on strategy.",
      },
      {
        moduleNumber: 8,
        heading: "Your Custom 2025 AI MARKETING ROADMAP",
        content:
          "Get a personalized plan showing exactly which AI tools to implement for YOUR challenges.",
      },
    ],
  },
                            {
    slug: "workshops/business-mastermind",
    modules: [
      {
        moduleNumber: 1,
        heading: "Your Personal AI MARKETING ASSISTANT That Works 24/7",
        content:
          "Create a Custom GPT that writes high-converting copy while you sleep!",
      },
      {
        moduleNumber: 2,
        heading: "The NO-CODE AUTOMATION BLUEPRINT That Saves 15+ Hours/Week",
        content:
          "Connect AI tools that automatically generate, schedule, and optimize your campaigns.",
      },
      {
        moduleNumber: 3,
        heading: "The VISUAL MARKETING MASTERY System:",
        content:
          "Create stunning images and videos using MidJourney and Runway ML (even with zero design skills).",
      },
      {
        moduleNumber: 4,
        heading: "The ONE-PERSON ARMY Marketing Blueprint:",
        content:
          "Build systems to single-handedly run campaigns that normally require 3-5 specialists.",
      },
      {
        moduleNumber: 5,
        heading: "The AI TOOL BLACK BOOK (35+ Cutting-Edge Tools):",
        content:
          "Get insider access to the FULL arsenal of AI marketing weapons beyond just ChatGPT.",
      },
        {
        moduleNumber: 6,
        heading: "The PERFECT PROMPT FORMULA For Guaranteed Results:",
        content:
          "Master our 5-part prompt structure that gets perfect results from any AI tool, every time.",
      },
      {
        moduleNumber: 7,
        heading: "The SET & FORGET Lead Generation System",
        content:
          "Build workflows that find, qualify, and nurture leads while you focus on strategy.",
      },
      {
        moduleNumber: 8,
        heading: "Your Custom 2025 AI MARKETING ROADMAP",
        content:
          "Get a personalized plan showing exactly which AI tools to implement for YOUR challenges.",
      },
    ],
  },
];

export default programModules;
